// ========================================
// SERVICE - Site Settings
// Gestion des paramètres du site
// ========================================

import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'siteSettings';
const DOC_ID = 'main';

// Structure par défaut des paramètres
const defaultSettings = {
  siteName: 'Gustave KONATE',
  siteDescription: 'Communiquer pour transformer, écrire pour inspirer, former pour bâtir l\'avenir.',
  logo: null,
  favicon: null,
  email: 'contactgkonate@gmail.com',
  phones: ['+226 70 11 64 34', '+226 76 96 57 05'],
  socialLinks: {
    linkedin: '',
    twitter: '',
    facebook: '',
    instagram: '',
    youtube: ''
  },
  footer: {
    copyright: '© 2025 Gustave KONATE. Tous droits réservés.'
  },
  seo: {
    defaultTitle: 'Gustave KONATE | Communicant & Leader Associatif',
    defaultDescription: 'Portfolio de Gustave KONATE - Communicant, Écrivain et Leader Associatif au Burkina Faso',
    googleAnalytics: ''
  }
};

/**
 * Récupérer les paramètres du site
 */
export const getSiteSettings = async () => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { success: true, data: { ...defaultSettings, ...docSnap.data() } };
    } else {
      // Créer les paramètres par défaut si n'existent pas
      await setDoc(docRef, defaultSettings);
      return { success: true, data: defaultSettings };
    }
  } catch (error) {
    console.error('Erreur getSiteSettings:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Mettre à jour les paramètres du site
 */
export const updateSiteSettings = async (settings) => {
  try {
    const docRef = doc(db, COLLECTION, DOC_ID);
    await updateDoc(docRef, {
      ...settings,
      updatedAt: new Date()
    });
    return { success: true };
  } catch (error) {
    console.error('Erreur updateSiteSettings:', error);
    return { success: false, error: error.message };
  }
};

export default {
  getSiteSettings,
  updateSiteSettings
};